import { useEffect } from "react";
import { Helmet } from 'react-helmet-async';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useTranslation } from "../../context/TranslationContext";

const ReturnRefundPolicy = () => {
    const { translateSync } = useTranslation();

    useEffect(() => {
        AOS.init({ duration: 1000, once: false, mirror: true });
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Helmet>
                <title>Return and Refund Policy | Colours Boutique</title>
                <meta name="description" content="Read the Colours Boutique return and refund policy for saree orders, exchange conditions, and refund timelines." />
                <link rel="canonical" href="https://coloursboutique.com/return-refund-policy" />
            </Helmet>

            <div className="home-saree-container">
                <section className="about-header-section text-center" style={{ paddingTop: "150px", paddingBottom: "20px" }}>
                    <div className="container">
                        <h1 className="fw-bold display-5 font-51" style={{ color: "#3a3530" }}>{translateSync('Return and Refund Policy')}</h1>
                        <nav aria-label="breadcrumb" className="boutique-breadcrumb-nav center-align">
                            <ol className="boutique-breadcrumb-ol boutique-breadcrumb-center">
                                <li className="breadcrumb-item"><span onClick={() => window.location.href = "/"}>{translateSync('Home')}</span></li>
                                <li className="breadcrumb-item active">{translateSync('Return & Refund')}</li>
                            </ol>
                        </nav>
                    </div>
                </section>

                <section className="training-transforms-section py-5 ">
                    <div className="container">
                        <div className="row align-items-stretch">
                            <div className="col-md-12 text-left justify-content-between">
                                <div className="aboutpage-content newww" >
                                    <div className="terms-content" style={{ lineHeight: '1.8' }}>
                                        <div className="mb-5" data-aos="fade-up" data-aos-delay="200">
                                            <h3 className="mb-3 fw-semibold" style={{ color: '#3a3530' }}>1. {translateSync('Return Window')}</h3>
                                            <p className="mb-0">
                                                {translateSync('We accept returns for exchanges or store credit within 7 days of order delivery. Because our silk sarees are handpicked, unique heritage pieces, direct refunds to cards are only issued under special circumstances or if an incorrect item was shipped.')}
                                            </p>
                                        </div>

                                        <div className="mb-5" data-aos="fade-up" data-aos-delay="300">
                                            <h3 className="mb-3 fw-semibold" style={{ color: '#3a3530' }}>2. {translateSync('Conditions for Return')}</h3>
                                            <p className="mb-2">
                                                {translateSync('To qualify for an exchange or store credit, items must be:')}
                                            </p>
                                            <ul className="list-unstyled">
                                                <li className="d-flex mb-2">
                                                    <span className="me-2" style={{ color: '#3a3530' }}>•</span>
                                                    <span>{translateSync('In their original, unworn, and unwashed condition.')}</span>
                                                </li>
                                                <li className="d-flex mb-2">
                                                    <span className="me-2" style={{ color: '#3a3530' }}>•</span>
                                                    <span>{translateSync('With all original tags, boutique packaging, and folders intact.')}</span>
                                                </li>
                                                <li className="d-flex">
                                                    <span className="me-2" style={{ color: '#3a3530' }}>•</span>
                                                    <span>{translateSync('Without any custom stitching (e.g. falls, edging, or blouse customization already done).')}</span>
                                                </li>
                                            </ul>
                                        </div>

                                        <div className="mb-5" data-aos="fade-up" data-aos-delay="400">
                                            <h3 className="mb-3 fw-semibold" style={{ color: '#3a3530' }}>3. {translateSync('Exchange Process')}</h3>
                                            <p className="mb-0">
                                                {translateSync('To initiate a return, contact our support team. Customers are responsible for return shipping charges unless the return is due to our shipping error.')}
                                            </p>
                                        </div>

                                        <div className="mb-5" data-aos="fade-up" data-aos-delay="500">
                                            <h3 className="mb-3 fw-semibold" style={{ color: '#3a3530' }}>4. {translateSync('Exclusions')}</h3>
                                            <p className="mb-0">
                                                {translateSync('Sale items, custom stitched blouses, custom embroidery works, and items bought during promotional campaigns are final sale and cannot be returned or exchanged.')}
                                            </p>
                                        </div>

                                        <div className="contact-info p-4 rounded-3" style={{ backgroundColor: "#f9f9f9" }} data-aos="fade-up" data-aos-delay="600">
                                            <h3 className="mb-3 fw-semibold" style={{ color: '#3a3530' }}>{translateSync('Need assistance?')}</h3>
                                            <ul className="list-unstyled">
                                                <li className="d-flex mb-2">
                                                    <span className="me-2" style={{ color: '#3a3530' }}>•</span>
                                                    <span>{translateSync('Email')}: <a href="mailto:coloursboutiqueadmin@gmail.com" className="text-decoration-none" style={{ color: "#3a3530" }}>coloursboutiqueadmin@gmail.com</a></span>
                                                </li>
                                                <li className="d-flex">
                                                    <span className="me-2" style={{ color: '#3a3530' }}>•</span>
                                                    <span>{translateSync('Phone')}: +91 80562 62626</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default ReturnRefundPolicy;
